import React from "react";
import { Box, Container } from "@mui/material";

interface IAppbarBase {
  height?: string;
  children: React.ReactNode;
}

function AppbarBase({ height = "60px", children }: IAppbarBase) {
  return (
    <Box component="header" sx={{ height, backgroundColor: "primary.main" }}>
      <Container maxWidth="sm" sx={{ width: "100%", height: "100%" }}>
        {children}
      </Container>
    </Box>
  );
}

export default AppbarBase;
